export type StocktakeCountValues = Record<string, Record<string, string>>;

export type StocktakeDraftRequestState = {
  requestId: number;
  currentRequestId: number;
  editRevision: number;
  currentEditRevision: number;
  paused: boolean;
  stocktakeStatus: string;
};

export function canSendStocktakeDraftRequest(state: StocktakeDraftRequestState) {
  return (
    state.stocktakeStatus === "active" &&
    !state.paused &&
    state.requestId === state.currentRequestId &&
    state.editRevision === state.currentEditRevision
  );
}

type StocktakeCountPart = {
  unitId: string;
  count: number;
};

type StocktakeLine = {
  productId: string;
  countedAt?: string | null;
  countBreakdown?: StocktakeCountPart[];
  units?: Array<{ id: string; active: number | boolean }>;
  packaging?: { parts?: StocktakeCountPart[] } | null;
  draftCounts?: Record<string, string | number>;
};

export function initialStocktakeCounts(stocktake: { lines?: StocktakeLine[] }) {
  const counts: StocktakeCountValues = {};
  const draftCounts = (
    stocktake as { draft?: { counts?: Record<string, Record<string, string | number>> } }
  ).draft?.counts;

  for (const line of stocktake.lines ?? []) {
    const lineCounts = Object.fromEntries(
      (line.units ?? []).filter((unit) => Boolean(unit.active)).map((unit) => [unit.id, "0"]),
    );
    const draftLine = draftCounts?.[line.productId];
    if (draftLine) {
      for (const unit of line.units ?? []) {
        if (!unit.active) continue;
        lineCounts[unit.id] = Object.hasOwn(draftLine, unit.id) ? String(draftLine[unit.id]) : "";
      }
      counts[line.productId] = lineCounts;
      continue;
    }
    const hasSavedCounts = Boolean(line.countedAt) || Boolean(line.countBreakdown?.length);
    const sourceParts = hasSavedCounts
      ? (line.countBreakdown ?? [])
      : (line.packaging?.parts ?? []);

    for (const part of sourceParts) {
      if (Object.hasOwn(lineCounts, part.unitId)) {
        lineCounts[part.unitId] = String(part.count);
      }
    }

    counts[line.productId] = lineCounts;
  }

  return counts;
}
